module.exports = __webpack_public_path__ + "media/julio_morning.a37c447d.mp4";